"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _fromUnixTime = _interopRequireDefault(require("date-fns/fromUnixTime"));
var _getUnixTime = _interopRequireDefault(require("date-fns/getUnixTime"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _DatePicker = _interopRequireDefault(require("../../../DatePicker"));
var _EditableSubject = _interopRequireDefault(require("../../../EditableSubject"));
var _ManagerSelector = _interopRequireDefault(require("../../Clients/ManagerSelector"));
var _Selector = _interopRequireDefault(require("../../Common/Selector"));
var _TicketFilterByTag = _interopRequireDefault(require("../TicketFilterByTag"));
var _TicketId = _interopRequireDefault(require("../TicketId"));
var _TicketStatus = _interopRequireDefault(require("../TicketStatus"));
var _TicketStatusSelector = _interopRequireDefault(require("../TicketStatusSelector"));
var _TicketType = _interopRequireWildcard(require("../TicketType"));
var _TicketTypeSelector = _interopRequireDefault(require("../TicketTypeSelector"));
var _TicketCloseReason = _interopRequireDefault(require("../TicketCloseReason"));
var _Tooltip = _interopRequireDefault(require("../../../Tooltip"));
var _Timer = _interopRequireDefault(require("../Timer"));
var _TicketAssignCheckbox = _interopRequireDefault(require("../TicketAssignCheckbox"));
var _constants = require("../../../../constants");
var _TicketViewingManagersList = _interopRequireDefault(require("../TicketViewingManagersList"));
var _Bubble = _interopRequireDefault(require("../../../Bubble"));
var _excluded = ["options", "ticket", "onClose", "onOrderSearch", "onReserveTicket", "isTicketReservationLoading", "extraInfo"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /*
  TODO: // Переписать компонент на TypeScript
  @see https://leveltravel.atlassian.net/browse/LT-23506
*/
var SOURCES = {
  MESSAGE: 'message',
  EMAIL: 'email'
};
var requiredFieldsTexts = {
  REASON: 'причина обращения',
  MANAGER: 'ответственный',
  SUBJECT: 'тема',
  MAILGROUP: 'группа'
};
var STATUSES = _TicketStatus["default"].STATUSES,
  PRIORITIES = _TicketStatus["default"].PRIORITIES,
  statusPropTypes = _TicketStatus["default"].propTypes;
var typePropTypes = _TicketType["default"].propTypes;
var Ticket = /*#__PURE__*/function (_React$PureComponent) {
  function Ticket(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Ticket);
    _this = _callSuper(this, Ticket, [props]);
    var dynamicStateFields = Ticket.getDynamicStateFields(props);
    _this.state = _objectSpread(_objectSpread({}, dynamicStateFields), {}, {
      isOpenRulesToolTip: false
    });
    _this.handleCreate = _this.handleCreate.bind(_this);
    _this.handleFieldSave = _this.handleFieldSave.bind(_this);
    _this.handleMailGroupChange = _this.handleMailGroupChange.bind(_this);
    _this.handleReasonChange = _this.handleReasonChange.bind(_this);
    _this.handleManagerChange = _this.handleManagerChange.bind(_this);
    _this.handleTicketReserve = _this.handleTicketReserve.bind(_this);
    _this.handlePlannedTimeChange = _this.handlePlannedTimeChange.bind(_this);
    _this.handleSourceChange = _this.handleSourceChange.bind(_this);
    _this.handleClickStatus = _this.handleClickStatus.bind(_this);
    _this.handleStatusChange = _this.handleStatusChange.bind(_this);
    _this.handleSubjectChange = _this.handleSubjectChange.bind(_this);
    _this.handleTagChange = _this.handleTagChange.bind(_this);
    _this.handleTypeChange = _this.handleTypeChange.bind(_this);
    _this.toggleRulesToolTip = _this.toggleRulesToolTip.bind(_this);
    _this.setInitialStatus = _this.setInitialStatus.bind(_this);
    _this.renderPlanReasonSelect = _this.renderPlanReasonSelect.bind(_this);
    _this.handlePlannedReasonChange = _this.handlePlannedReasonChange.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(Ticket, _React$PureComponent);
  return (0, _createClass2["default"])(Ticket, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;
      this.setState(function () {
        return Ticket.getDynamicStateFields(nextProps, _this2.props);
      });
    }
  }, {
    key: "handleStatusChange",
    value: function handleStatusChange(_ref) {
      var _this3 = this;
      var detail = _ref.detail;
      var status = detail.value;
      var _this$state = this.state,
        type = _this$state.type,
        reasonOption = _this$state.reasonOption;
      var isTypeTourSelection = type === _TicketType.TYPES.TOUR_SELECTION;
      var isClosable = !!reasonOption;
      var localChange = STATUSES.PLANNED === status;
      if ((!isClosable || isTypeTourSelection) && status === STATUSES.CLOSED) {
        localChange = true;
      }
      this.setState({
        status: status
      }, function () {
        return !localChange && _this3.handleFieldSave({
          status: status
        });
      });
    }
  }, {
    key: "handleManagerChange",
    value: function handleManagerChange(_ref2) {
      var _this4 = this;
      var manager = _ref2.value;
      var _this$props = this.props,
        ticket = _this$props.ticket,
        onReserveTicket = _this$props.onReserveTicket;
      var isAssigned = this.state.isAssigned;
      var ticketId = (0, _get2["default"])(ticket, 'id');
      this.setState({
        manager: manager
      }, function () {
        return _this4.handleFieldSave({
          manager: manager
        });
      });

      // снимаем закрепление тикета за менеджером, если произошло удаление ответственного
      if (!manager && isAssigned) {
        this.setState({
          isAssigned: false
        });
        if (ticketId) {
          onReserveTicket(false);
        }
      }
    }
  }, {
    key: "handleTicketReserve",
    value: function handleTicketReserve(isAssigned) {
      var _this$props2 = this.props,
        ticket = _this$props2.ticket,
        onReserveTicket = _this$props2.onReserveTicket;
      var ticketId = (0, _get2["default"])(ticket, 'id');
      this.setState({
        isAssigned: isAssigned
      });
      if (ticketId) {
        onReserveTicket(isAssigned);
      }
    }
  }, {
    key: "handleSubjectChange",
    value: function handleSubjectChange(_ref3) {
      var _this5 = this;
      var subject = _ref3.value;
      this.setState({
        subject: subject
      }, function () {
        return _this5.handleFieldSave({
          subject: subject
        });
      });
    }
  }, {
    key: "handleTagChange",
    value: function handleTagChange(_ref4) {
      var _this6 = this;
      var target = _ref4.target;
      var value = target.value;
      var tags = value || [];
      this.setState({
        tags: tags
      }, function () {
        return _this6.handleFieldSave({
          tags: tags
        });
      });
    }
  }, {
    key: "handlePlannedTimeChange",
    value: function handlePlannedTimeChange(value) {
      var _this7 = this;
      var planReason = this.state.planReason;
      var date = new Date(value);
      this.setState({
        plannedAt: (0, _getUnixTime["default"])(date)
      }, function () {
        return _this7.handleFieldSave({
          plannedAt: date,
          planReasonId: planReason === null || planReason === void 0 ? void 0 : planReason.value,
          status: STATUSES.PLANNED
        });
      });
    }
  }, {
    key: "handleClickStatus",
    value: function handleClickStatus(status) {
      if (status === STATUSES.PLANNED) {
        this.setState(function () {
          return {
            plannedAt: null
          };
        });
      }
    }
  }, {
    key: "handleTypeChange",
    value: function handleTypeChange(value) {
      var _this8 = this;
      var options = this.props.options;
      var selectedOption = (0, _find2["default"])(options.types, {
        value: value
      });
      var type = (0, _get2["default"])(selectedOption, 'type');
      var subtype = (0, _get2["default"])(selectedOption, 'subtype');
      var typeOption = (0, _get2["default"])(selectedOption, 'value');
      this.setState({
        type: type,
        subtype: subtype,
        typeOption: typeOption
      }, function () {
        return _this8.handleFieldSave({
          type: type,
          subtype: subtype
        });
      });
    }
  }, {
    key: "handlePlannedReasonChange",
    value: function handlePlannedReasonChange(reason) {
      this.setState(function () {
        return {
          planReason: reason
        };
      });
    }
  }, {
    key: "handleMailGroupChange",
    value: function handleMailGroupChange(mailGroupOption) {
      var _this9 = this;
      var mailGroup = mailGroupOption.value;
      this.setState({
        mailGroupOption: mailGroupOption,
        mailGroup: mailGroup
      }, function () {
        return _this9.handleFieldSave({
          mailGroup: mailGroup
        });
      });
    }
  }, {
    key: "handleSourceChange",
    value: function handleSourceChange(menuSourceOption) {
      var _this10 = this;
      var menuSource = menuSourceOption.value;
      this.setState({
        menuSourceOption: menuSourceOption
      }, function () {
        return _this10.handleFieldSave({
          menuSource: menuSource
        });
      });
    }
  }, {
    key: "handleReasonChange",
    value: function handleReasonChange(reasonOption) {
      var _this11 = this;
      var reason = reasonOption.value;
      this.setState({
        reasonOption: reasonOption,
        reason: reason
      }, function () {
        return _this11.handleFieldSave({
          reason: reason
        });
      });
    }
  }, {
    key: "handleFieldSave",
    value: function handleFieldSave(value) {
      var _this$props3 = this.props,
        ticket = _this$props3.ticket,
        onFieldChange = _this$props3.onFieldChange;
      var id = (0, _get2["default"])(ticket, 'id');
      if (!id) {
        return;
      }
      onFieldChange(value);
    }
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      var onCreate = this.props.onCreate;
      var plannedAt;
      var _this$state2 = this.state,
        reason = _this$state2.reason,
        mailGroup = _this$state2.mailGroup,
        manager = _this$state2.manager,
        isAssigned = _this$state2.isAssigned,
        plannedAtUnix = _this$state2.plannedAt,
        status = _this$state2.status,
        subject = _this$state2.subject,
        subtype = _this$state2.subtype,
        tags = _this$state2.tags,
        type = _this$state2.type;
      if (plannedAtUnix) {
        plannedAt = (0, _fromUnixTime["default"])(plannedAtUnix);
      }
      onCreate({
        reason: reason,
        mailGroup: mailGroup,
        manager: manager,
        isAssigned: isAssigned,
        status: status,
        subject: subject,
        tags: tags,
        type: type,
        subtype: subtype,
        plannedAt: plannedAt
      });
    }
  }, {
    key: "setInitialStatus",
    value: function setInitialStatus() {
      var ticket = this.props.ticket;
      var status = (0, _get2["default"])(ticket, 'status.title');
      this.setState({
        status: status
      });
    }
  }, {
    key: "toggleRulesToolTip",
    value: function toggleRulesToolTip() {
      this.setState(function (prevState) {
        return {
          isOpenRulesToolTip: !prevState.isOpenRulesToolTip
        };
      });
    }
  }, {
    key: "renderPlanReasonSelect",
    value: function renderPlanReasonSelect() {
      var planReason = this.state.planReason;
      var options = this.props.options;
      var planReasons = options.planReasons;
      return /*#__PURE__*/_react["default"].createElement("span", {
        onChange: function onChange(event) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, /*#__PURE__*/_react["default"].createElement(StyledPlanReasonSelector, {
        isSearchable: true,
        value: planReason,
        options: planReasons,
        onChange: this.handlePlannedReasonChange
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        options = _this$props4.options,
        ticket = _this$props4.ticket,
        onClose = _this$props4.onClose,
        onOrderSearch = _this$props4.onOrderSearch,
        onReserveTicket = _this$props4.onReserveTicket,
        isTicketReservationLoading = _this$props4.isTicketReservationLoading,
        extraInfo = _this$props4.extraInfo,
        props = (0, _objectWithoutProperties2["default"])(_this$props4, _excluded);
      var id = (0, _get2["default"])(ticket, 'id');
      var source = (0, _get2["default"])(ticket, 'source');
      var ruleIds = (0, _get2["default"])(ticket, 'ruleIds');
      var closeReason = (0, _get2["default"])(ticket, 'closeReason');
      var orderIds = (0, _get2["default"])(ticket, 'orderIds');
      var priority = (0, _get2["default"])(ticket, 'status.priority');
      var ltt = (0, _get2["default"])(ticket, 'ltt');
      var sla = (0, _get2["default"])(ticket, 'sla');
      var assignedAt = (0, _get2["default"])(ticket, 'assignedAt');
      var createdAt = (0, _get2["default"])(ticket, 'createdAt');
      var statusChangedAt = (0, _get2["default"])(ticket, 'statusChangedAt');
      var reasons = options.reasons,
        closeReasons = options.closeReasons,
        managers = options.managers,
        tagOptions = options.tags,
        types = options.types,
        menuSources = options.menuSources,
        orders = options.orders,
        mailGroups = options.mailGroups,
        suggestedOrders = options.suggestedOrders;
      var _this$state3 = this.state,
        reason = _this$state3.reason,
        reasonOption = _this$state3.reasonOption,
        isOpenRulesToolTip = _this$state3.isOpenRulesToolTip,
        mailGroup = _this$state3.mailGroup,
        mailGroupOption = _this$state3.mailGroupOption,
        manager = _this$state3.manager,
        isAssigned = _this$state3.isAssigned,
        plannedAt = _this$state3.plannedAt,
        planReason = _this$state3.planReason,
        status = _this$state3.status,
        subject = _this$state3.subject,
        tags = _this$state3.tags,
        menuSourceOption = _this$state3.menuSourceOption,
        type = _this$state3.type,
        typeOption = _this$state3.typeOption,
        closeReasonOption = _this$state3.closeReasonOption;
      var isExistMandatoryFields = !!reason && !!manager && !!subject && !!mailGroup;
      var isTypeTourSelection = type === _TicketType.TYPES.TOUR_SELECTION;
      var isStatusPlanned = status === STATUSES.PLANNED;
      var showRules = !isTypeTourSelection && ruleIds && ruleIds.length > 0;
      var isClosable = !!reasonOption;
      var showCloseReasons = (!isClosable || isTypeTourSelection) && status === STATUSES.CLOSED && !closeReason;
      var isLoadingTicketReservation = id ? isTicketReservationLoading : false;
      var isDisabledTicketReservation = !manager || isLoadingTicketReservation;

      // из assignedAt и statusChangedAt выбираем ту дату, которая позже (assignedAt - в формате ISO, statusChangedAt - в секундах)
      var getSlaSubtrahendTime = function getSlaSubtrahendTime() {
        var assignedAtDate = new Date(assignedAt);
        var statusChangedAtDate = new Date(statusChangedAt * 1000);
        return (assignedAtDate > statusChangedAtDate ? assignedAtDate : statusChangedAtDate).toISOString();
      };
      var getLttSubtrahendTime = function getLttSubtrahendTime() {
        return new Date(createdAt * 1000).toISOString();
      };
      var createTicketButtonTooltipContent = function createTicketButtonTooltipContent() {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "\u041D\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u044B \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u043F\u043E\u043B\u044F:", !subject && /*#__PURE__*/_react["default"].createElement("div", null, "\u2022 ".concat(requiredFieldsTexts.SUBJECT)), !manager && /*#__PURE__*/_react["default"].createElement("div", null, "\u2022 ".concat(requiredFieldsTexts.MANAGER)), !mailGroup && /*#__PURE__*/_react["default"].createElement("div", null, "\u2022 ".concat(requiredFieldsTexts.MAILGROUP)), !reason && /*#__PURE__*/_react["default"].createElement("div", null, "\u2022 ".concat(requiredFieldsTexts.REASON)));
      };
      return /*#__PURE__*/_react["default"].createElement(StyledTicket, (0, _extends2["default"])({}, props, {
        onClick: this.handleEdit
      }), /*#__PURE__*/_react["default"].createElement(StyledHeader, null, id && /*#__PURE__*/_react["default"].createElement(_TicketId["default"], {
        id: "\u0422\u0438\u043A\u0435\u0442 ".concat(id)
      }), showRules && /*#__PURE__*/_react["default"].createElement(StyledRules, {
        onClick: this.toggleRulesToolTip
      }, "\u041F\u0440\u0430\u0432\u0438\u043B\u0430", /*#__PURE__*/_react["default"].createElement(StyledRulesTooltip, {
        hideAction: this.toggleRulesToolTip,
        shown: isOpenRulesToolTip,
        width: 200
      }, ruleIds.map(function (ruleId, index) {
        return /*#__PURE__*/_react["default"].createElement("span", null, "".concat(index + 1, ") "), /*#__PURE__*/_react["default"].createElement("a", {
          href: "https://level.travel/admin/crm_rules/".concat(ruleId),
          target: "_blank",
          rel: "noopener noreferrer"
        }, ruleId));
      })))), /*#__PURE__*/_react["default"].createElement(_EditableSubject["default"], {
        placeholder: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0442\u0435\u043C\u0443 \u0442\u0438\u043A\u0435\u0442\u0430",
        value: subject,
        onSubmit: this.handleSubjectChange,
        isRequired: !id
      }), /*#__PURE__*/_react["default"].createElement(StyledTicketStatusSelector, {
        type: type,
        value: status,
        priority: priority,
        time: isStatusPlanned && plannedAt || null,
        onChange: this.handleStatusChange,
        onClickStatus: this.handleClickStatus,
        orderIds: orderIds,
        closeReason: closeReasonOption,
        planReason: planReason
      }), ticket && ltt && /*#__PURE__*/_react["default"].createElement(StyledLTTTime, {
        subtrahendTime: getLttSubtrahendTime(),
        seconds: ltt,
        type: "LTT"
      }), ticket && sla && manager && /*#__PURE__*/_react["default"].createElement(StyledSLATime, {
        subtrahendTime: getSlaSubtrahendTime(),
        seconds: sla,
        type: "SLA"
      }), showCloseReasons && /*#__PURE__*/_react["default"].createElement(_TicketCloseReason["default"], {
        orderIds: orderIds,
        reasonOptions: closeReasons,
        suggestedOrders: suggestedOrders,
        orderOptions: orders,
        onClose: this.setInitialStatus,
        onSubmit: onClose,
        onOrderSearch: onOrderSearch,
        isClosable: isClosable
      }), isStatusPlanned && !plannedAt && /*#__PURE__*/_react["default"].createElement(StyledDatePicker, {
        showTimeSelect: true,
        forceShown: true,
        minDate: new Date(),
        showShortcuts: true,
        submitLabel: "\u041D\u0430\u043F\u043E\u043C\u043D\u0438\u0442\u044C",
        onChange: this.handlePlannedTimeChange,
        suffix: this.renderPlanReasonSelect()
      }), types && /*#__PURE__*/_react["default"].createElement(StyledTypeSelector, {
        value: typeOption,
        options: types,
        onChange: this.handleTypeChange
      }), /*#__PURE__*/_react["default"].createElement(StyledTagSelector, {
        isSearchable: true,
        onChange: this.handleTagChange,
        tags: tagOptions,
        value: tags
      }), managers && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledManagerSelector, {
        onChange: this.handleManagerChange,
        managers: managers,
        value: manager,
        isRequired: !id
      }), /*#__PURE__*/_react["default"].createElement(StyledTicketAssignCheckbox, {
        checked: isAssigned,
        disabled: isDisabledTicketReservation,
        isLoading: isLoadingTicketReservation,
        onReserveTicket: this.handleTicketReserve
      })), SOURCES.MESSAGE === source && menuSources && menuSourceOption && /*#__PURE__*/_react["default"].createElement(StyledSourcesSelector, {
        isDisabled: true,
        options: menuSources,
        placeholder: "\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F",
        value: menuSourceOption,
        onChange: this.handleSourceChange
      }), mailGroups && /*#__PURE__*/_react["default"].createElement(StyledMailGroupSelector, {
        isSearchable: true,
        onChange: this.handleMailGroupChange,
        options: mailGroups,
        placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0433\u0440\u0443\u043F\u043F\u0443",
        value: mailGroupOption,
        isRequired: !id
      }), reasons && /*#__PURE__*/_react["default"].createElement(StyledReasonSelector, {
        isSearchable: true,
        onChange: this.handleReasonChange,
        options: reasons,
        placeholder: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F",
        value: reasonOption,
        isRequired: !id
      }), !!(extraInfo !== null && extraInfo !== void 0 && extraInfo.viewingManagersIds) && /*#__PURE__*/_react["default"].createElement(_TicketViewingManagersList["default"], {
        managers: managers,
        viewingManagersIds: extraInfo.viewingManagersIds
      }), !id && /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        text: createTicketButtonTooltipContent(),
        placement: "top",
        disabled: isExistMandatoryFields
      }, /*#__PURE__*/_react["default"].createElement(StyledButton, {
        "data-tooltip-id": "create-ticket-button",
        disabled: !isExistMandatoryFields,
        onClick: this.handleCreate
      }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0442\u0438\u043A\u0435\u0442")));
    }
  }], [{
    key: "getDynamicStateFields",
    value: function getDynamicStateFields(aProps, bProps) {
      var initialState = {
        subject: '',
        status: STATUSES.OPEN,
        type: _TicketType.TYPES.UNKNOWN,
        subtype: '',
        typeOption: '',
        mailGroup: null,
        reason: null,
        mailGroupOption: null,
        reasonOption: null,
        tags: [],
        manager: null,
        isAssigned: false,
        planReason: null,
        plannedAt: null,
        menuSource: null
      };
      var state = {};
      if (JSON.stringify(aProps.ticket) !== JSON.stringify((0, _get2["default"])(bProps, 'ticket'))) {
        var mailGroupsOptions = (0, _get2["default"])(aProps, 'options.mailGroups');
        var menuSourcesOptions = (0, _get2["default"])(aProps, 'options.menuSources');
        var typeOptions = (0, _get2["default"])(aProps, 'options.types');
        var closeReasonOptions = (0, _get2["default"])(aProps, 'options.closeReasons');
        var planReasons = (0, _get2["default"])(aProps, 'options.planReasons', []);
        var plannedReasonId = (0, _get2["default"])(aProps, 'ticket.plannedReasonId');
        var reasonOptions = (0, _get2["default"])(aProps, 'options.reasons', []);
        state.type = (0, _get2["default"])(aProps, 'ticket.type') || initialState.type;
        state.menuSource = (0, _get2["default"])(aProps, 'ticket.menuSource') || initialState.menuSource;
        state.subtype = (0, _get2["default"])(aProps, 'ticket.subtype') || initialState.subtype;
        state.mailGroup = (0, _get2["default"])(aProps, 'ticket.mailGroup') || initialState.mailGroup;
        state.reason = (0, _get2["default"])(aProps, 'ticket.reason') || initialState.reason;
        state.closeReason = (0, _get2["default"])(aProps, 'ticket.closeReason') || initialState.closeReason;
        state.subject = (0, _get2["default"])(aProps, 'ticket.subject') || initialState.subject;
        state.status = (0, _get2["default"])(aProps, 'ticket.status.title') || initialState.status;
        state.tags = (0, _get2["default"])(aProps, 'ticket.tags') || initialState.tags;
        state.manager = (0, _get2["default"])(aProps, 'ticket.manager') || initialState.manager;
        state.isAssigned = (0, _get2["default"])(aProps, 'ticket.isAssigned') || initialState.isAssigned;
        state.plannedAt = (0, _get2["default"])(aProps, 'ticket.plannedAt') || initialState.plannedAt;
        state.typeSelectedOption = (0, _find2["default"])(typeOptions, {
          type: state.type,
          subtype: state.subtype
        }) || initialState.typeSelectedOption;
        state.mailGroupOption = (0, _find2["default"])(mailGroupsOptions, {
          value: state.mailGroup
        }) || initialState.mailGroupOption;
        state.menuSourceOption = (0, _find2["default"])(menuSourcesOptions, {
          value: state.menuSource
        }) || initialState.menuSourceOption;
        state.reasonOption = (0, _find2["default"])(reasonOptions, {
          value: state.reason
        }) || initialState.reasonOption;
        state.typeOption = (0, _get2["default"])(state.typeSelectedOption, 'value') || initialState.typeOption;
        state.closeReasonOption = (0, _find2["default"])(closeReasonOptions, {
          value: state.closeReason
        }) || initialState.typeOption;
        state.planReason = planReasons.find(function (_ref5) {
          var value = _ref5.value;
          return value === plannedReasonId;
        }) || initialState.planReason;
      }
      return state;
    }
  }]);
}(_react["default"].PureComponent);
Ticket.propTypes = {
  className: _propTypes["default"].string,
  readOnly: _propTypes["default"].bool,
  ticket: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    mailGroup: _propTypes["default"].string,
    manager: _propTypes["default"].string,
    status: _propTypes["default"].shape(statusPropTypes),
    subject: _propTypes["default"].string.isRequired,
    subtype: _propTypes["default"].string,
    plannedAt: _propTypes["default"].string,
    priority: _propTypes["default"].string,
    hasPriorityService: _propTypes["default"].bool,
    reason: _propTypes["default"].string,
    menuSource: _propTypes["default"].string,
    tagIds: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired),
    tags: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired),
    type: _propTypes["default"].oneOf(Object.values(_TicketType.TYPES)).isRequired,
    source: _propTypes["default"].oneOf(Object.values(SOURCES)).isRequired,
    ruleIds: _propTypes["default"].arrayOf(_propTypes["default"].number.isRequired),
    orderIds: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired),
    closeReason: _propTypes["default"].string,
    assignedAt: _propTypes["default"].string,
    createdAt: _propTypes["default"].number,
    updatedAt: _propTypes["default"].number
  }).isRequired,
  options: _propTypes["default"].shape({
    types: _propTypes["default"].arrayOf(_propTypes["default"].shape(_objectSpread(_objectSpread({}, typePropTypes), {}, {
      title: _propTypes["default"].string.isRequired,
      value: _propTypes["default"].string.isRequired
    })).isRequired).isRequired,
    managers: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      // ...managerPropTypes,
      // Поскольку компонент Manager теперь на TS, убираем зависимость
      avatarUrl: _propTypes["default"].string,
      className: _propTypes["default"].string,
      name: _propTypes["default"].string.isRequired,
      phone: _propTypes["default"].string,
      status: _propTypes["default"].oneOf(Object.values(_constants.MANAGER_STATUSES)),
      title: _propTypes["default"].string.isRequired,
      value: _propTypes["default"].string.isRequired
    }).isRequired),
    tags: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].string.isRequired,
      value: _propTypes["default"].string.isRequired
    }).isRequired),
    mailGroups: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].string.isRequired,
      value: _propTypes["default"].string.isRequired
    }).isRequired),
    closeReasons: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].string.isRequired,
      value: _propTypes["default"].string.isRequired
    }).isRequired),
    orders: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].string.isRequired,
      value: _propTypes["default"].string.isRequired
    }).isRequired),
    planReasons: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].string.isRequired,
      value: _propTypes["default"].string.isRequired
    }).isRequired),
    reasons: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].string.isRequired,
      value: _propTypes["default"].string.isRequired
    }).isRequired),
    menuSources: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].string.isRequired,
      value: _propTypes["default"].string.isRequired
    }).isRequired)
  }),
  onCreate: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onFieldChange: _propTypes["default"].func,
  onManagerChange: _propTypes["default"].func,
  onSubjectChange: _propTypes["default"].func,
  onTagChange: _propTypes["default"].func,
  onTypeChange: _propTypes["default"].func,
  onOrderSearch: _propTypes["default"].func
};
Ticket.defaultProps = {
  className: '',
  readOnly: false,
  options: {
    reasons: null,
    mailGroups: null,
    managers: null,
    tags: [],
    types: null,
    closeReasons: [],
    orders: [],
    planReasons: [],
    menuSources: null
  },
  onCreate: Function.prototype,
  onClose: Function.prototype,
  onFieldChange: Function.prototype,
  onManagerChange: Function.prototype,
  onSubjectChange: Function.prototype,
  onTagChange: Function.prototype,
  onTypeChange: Function.prototype,
  onOrderSearch: Function.prototype
};
var StyledTicket = _styledComponents["default"].div.withConfig({
  displayName: "Ticket__StyledTicket",
  componentId: "sc-1i7rtqj-0"
})(["width:100%;"]);
var StyledHeader = _styledComponents["default"].div.withConfig({
  displayName: "Ticket__StyledHeader",
  componentId: "sc-1i7rtqj-1"
})(["display:flex;justify-content:space-between;"]);
var StyledRules = _styledComponents["default"].div.withConfig({
  displayName: "Ticket__StyledRules",
  componentId: "sc-1i7rtqj-2"
})(["color:#919499;font-size:12px;text-transform:uppercase;cursor:pointer;"]);
var StyledRulesTooltip = (0, _styledComponents["default"])(_Tooltip["default"]).withConfig({
  displayName: "Ticket__StyledRulesTooltip",
  componentId: "sc-1i7rtqj-3"
})(["display:flex;font-size:14px;flex-direction:column;top:calc(100% + 10px);bottom:auto;a{color:#007aff;}::after{top:-9px;bottom:0;left:calc(50% - 9px);border-top:none;border-bottom:9px solid #fff;border-left:9px solid transparent;border-right:9px solid transparent;}"]);
var StyledTicketStatusSelector = (0, _styledComponents["default"])(_TicketStatusSelector["default"]).withConfig({
  displayName: "Ticket__StyledTicketStatusSelector",
  componentId: "sc-1i7rtqj-4"
})(["width:100%;"]);
var StyledTypeSelector = (0, _styledComponents["default"])(_TicketTypeSelector["default"]).withConfig({
  displayName: "Ticket__StyledTypeSelector",
  componentId: "sc-1i7rtqj-5"
})(["margin-top:8px;"]);
var StyledManagerSelector = (0, _styledComponents["default"])(_ManagerSelector["default"]).withConfig({
  displayName: "Ticket__StyledManagerSelector",
  componentId: "sc-1i7rtqj-6"
})(["margin-top:5px;"]);
var StyledTagSelector = (0, _styledComponents["default"])(_TicketFilterByTag["default"]).withConfig({
  displayName: "Ticket__StyledTagSelector",
  componentId: "sc-1i7rtqj-7"
})(["margin-top:10px;min-height:30px;line-height:30px;"]);
var StyledMailGroupSelector = (0, _styledComponents["default"])(_Selector["default"]).withConfig({
  displayName: "Ticket__StyledMailGroupSelector",
  componentId: "sc-1i7rtqj-8"
})(["height:30px;line-height:30px;"]);
var StyledReasonSelector = (0, _styledComponents["default"])(_Selector["default"]).withConfig({
  displayName: "Ticket__StyledReasonSelector",
  componentId: "sc-1i7rtqj-9"
})(["height:30px;line-height:30px;"]);
var StyledSourcesSelector = (0, _styledComponents["default"])(_Selector["default"]).withConfig({
  displayName: "Ticket__StyledSourcesSelector",
  componentId: "sc-1i7rtqj-10"
})(["margin-top:5px;height:30px;line-height:30px;"]);
var StyledPlanReasonSelector = (0, _styledComponents["default"])(_Selector["default"]).withConfig({
  displayName: "Ticket__StyledPlanReasonSelector",
  componentId: "sc-1i7rtqj-11"
})(["height:30px;line-height:30px;padding:0 10px;margin-bottom:10px;"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "Ticket__StyledButton",
  componentId: "sc-1i7rtqj-12"
})(["background:transparent;height:36px;margin-top:10px;"]);
var StyledDatePicker = (0, _styledComponents["default"])(_DatePicker["default"]).withConfig({
  displayName: "Ticket__StyledDatePicker",
  componentId: "sc-1i7rtqj-13"
})(["flex:1;height:0;margin-left:-2px;"]);
var StyledTicketAssignCheckbox = (0, _styledComponents["default"])(_TicketAssignCheckbox["default"]).withConfig({
  displayName: "Ticket__StyledTicketAssignCheckbox",
  componentId: "sc-1i7rtqj-14"
})(["margin-top:5px;"]);
var StyledSLATime = (0, _styledComponents["default"])(_Timer["default"]).withConfig({
  displayName: "Ticket__StyledSLATime",
  componentId: "sc-1i7rtqj-15"
})(["margin-bottom:5px;"]);
var StyledLTTTime = (0, _styledComponents["default"])(_Timer["default"]).withConfig({
  displayName: "Ticket__StyledLTTTime",
  componentId: "sc-1i7rtqj-16"
})(["margin:0 5px 5px 0;"]);
Ticket.STATUS_PRIORITIES = PRIORITIES;
Ticket.TYPES = _TicketType.TYPES;
Ticket.SUBTYPES = _TicketType.SUBTYPES;
var _default = exports["default"] = Ticket;